import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[sag-ui-menu-trigger]',
})
export class MenuTriggerDirective implements OnInit {
  @Input() menuTriggerFor = '';
  @Input() menuAction: 'hide' | 'show' | 'toggle' = 'toggle';
  @Input() menuPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() menuOffsetBottom = 0;
  @Input() menuOffsetLeft = 0;
  @Input() menuOffsetRight = 0;
  @Input() menuOffsetTop = 0;

  private menuOpen = false;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.setAttribute(
      'popovertarget',
      this.menuTriggerFor
    );
    this.elementRef.nativeElement.setAttribute(
      'popovertargetaction',
      this.menuAction
    );

    const triggerElement = this.elementRef.nativeElement;

    const handleToggle = (event: Event) => {
      switch ((event as any).newState) {
        case 'open':
          this.menuOpen = true;
          break;
        case 'closed':
          this.menuOpen = false;
          break;
        default:
          this.menuOpen = false;
          break;
      }
    };

    triggerElement.addEventListener('mouseenter', () => {
      const menuElement = document.getElementById(this.menuTriggerFor);
      if (!menuElement) return;

      menuElement.addEventListener('toggle', handleToggle);

      if (this.elementRef.nativeElement.tagName === 'SAG-UI-MENU-ITEM') {
        menuElement.showPopover();
      }

      this.positionMenu(triggerElement, menuElement);
    });

    triggerElement.addEventListener('click', () => {
      const menuElement = document.getElementById(this.menuTriggerFor);
      if (!menuElement) return;

      switch (this.menuAction) {
        case 'hide':
          menuElement.hidePopover();
          break;
        case 'show':
          menuElement.showPopover();
          break;
        case 'toggle':
          this.menuOpen = !this.menuOpen;
          this.menuOpen ? menuElement.showPopover() : menuElement.hidePopover();
          break;
      }

      this.positionMenu(triggerElement, menuElement);
    });

    window.addEventListener('resize', () => {
      const menuElement = document.getElementById(this.menuTriggerFor);
      if (!menuElement) return;

      this.positionMenu(triggerElement, menuElement);
    });
  }

  private positionMenu(trigger: HTMLElement, menu: HTMLElement): void {
    const triggerRect = trigger.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();

    const triggerTop = triggerRect.top + window.scrollY;
    const triggerLeft = triggerRect.left + window.scrollX;
    const triggerBottom = triggerRect.bottom + window.scrollY;
    const triggerRight = triggerRect.right + window.scrollX;

    const menuWidth = menuRect.width;
    const menuHeight = menuRect.height;

    const windowWidth = window.innerWidth;

    let left = 0;
    let top = 0;

    const menuOffsetLeft = this.menuOffsetLeft || 0;
    const menuOffsetRight = this.menuOffsetRight || 0;
    const menuOffsetTop = this.menuOffsetTop || 0;
    const menuOffsetBottom = this.menuOffsetBottom || 0;

    switch (this.menuPosition) {
      case 'top':
        left =
          triggerLeft +
          triggerRect.width / 2 -
          menuWidth / 2 +
          menuOffsetLeft -
          menuOffsetRight;
        top = triggerTop - menuHeight + menuOffsetTop - menuOffsetBottom;
        break;
      case 'bottom':
        left =
          triggerLeft +
          triggerRect.width / 2 -
          menuWidth / 2 +
          menuOffsetLeft -
          menuOffsetRight;
        top = triggerBottom + menuOffsetTop - menuOffsetBottom;
        break;
      case 'left':
        left = triggerLeft - menuWidth + menuOffsetLeft - menuOffsetRight;
        top = triggerTop + menuOffsetTop - menuOffsetBottom;
        break;
      case 'right':
        left = triggerRight + menuOffsetLeft - menuOffsetRight;
        top = triggerTop + menuOffsetTop - menuOffsetBottom;
        break;
      default:
        console.error('Invalid menu position:', this.menuPosition);
        return;
    }

    if (left < 0) {
      left = 0;
    } else if (left + menuWidth > windowWidth) {
      left = windowWidth - menuWidth;
    }

    if (top < 0) {
      top = 0;
    }

    menu.style.left = `${left}px`;
    menu.style.top = `${top}px`;
  }
}
